import React, { useContext } from 'react';
import ProjectConfig from '../constants';
import { I18nContext } from '../context/translations/TranslationsContext.context';

/**
 * Nota compartida por los modales de solicitar/gestionar un rescate
 * (SolicitarRescatePorMotivoDialogV2, RescueRequestDialogV2,
 * ConfigurarRentaMensualDialogV2) — mismo email de soporte que el resto de la
 * app (`ProjectConfig.ARCA_CONTACT.EMAIL`), no uno nuevo específico de rescates.
 */
const RescueSupportNoteV2: React.FC = () => {
	const {
		state: { translate }
	} = useContext(I18nContext);
	return (
		<p className="text-[11px] text-muted-foreground text-center">
			{translate('rescue.supportNote.text')}{' '}
			<a
				href={`mailto:${ProjectConfig.ARCA_CONTACT.EMAIL}`}
				className="underline hover:text-foreground"
			>
				{ProjectConfig.ARCA_CONTACT.EMAIL}
			</a>
			.
		</p>
	);
};

export default RescueSupportNoteV2;
